import ajax from '@/utils/ajax'

/**
 * @module 订单列表
 */

// 获取订单查询所需订单状态
export const getQueryOrderType = params => ajax.post('order/getAllOrderStatus', params)

// 获取订单查询所需油站列表
export const getQueryGasList = params => ajax.post('gasInfo/getAllGasInfoList', params)

// 获取订单查询所需油号列表
export const getOilNumList = params => ajax.get('/gasInfo/getAllOilNumList', params)

// 结算账单明细油号下拉列表
export const getAllStandardList = params => ajax.get('/gasInfo/getAllStandardList', params)

// 查询订单列表
export const queryOrderList = params => ajax.post('order/getOrdersByPage', params)

// 查询订单列表
export const getOrdersByPageNew = params => ajax.post('order/getOrdersByPageNew', params)

// 查询总金额
export const getSum = params => ajax.post('order/getSummary', params)

// 提交退款
export const submitRefund = params => ajax.post('order/applyRefund', params, { noMessage: true })

// 导出数据
export const exportData = params => ajax.post('order/exportOrdersExcel', params)

// 补打小票
export const makeSmallTicket = params => ajax.post('order/printTicket', params)

// 油站退款（确认退款）
export const confirmRefund = params => ajax.post('order/confirmRefund', params, { noMessage: true })

// 油站退款（拒绝退款）
export const rejectRefund = params => ajax.post('order/rejectRefund', params)

// 获取油站需要退款的订单数
export const getRefundNum = params => ajax.post('order/getRefundCountByGasId', params)

// 查询退款原因list
export const getRefundReason = params => ajax.post('order/getRefundReasonList', params)

// 查询开票数量
export const getInvoiceNum = params => ajax.post('invoice/gasApplyInvoiceTotal', params)

// 标记开票
export const confirmInvoice = params => ajax.post('order/mark/invoice', params)

// 撤销开票
export const revokeInvoice = params => ajax.post('order/revoke/invoice', params)

// 获取开票状态
export const getInvoiceStatus = params => ajax.get('order/invoice/status/list', params)

// 获取开票方
export const getInvoiceSource = params => ajax.get('order/invoice/flag/list', params)

/**
 * @module 订单详情
 */

// 获取订单详情
export const getOrderDetail = params => ajax.post('order/orderDetail', params)

/**
 * @module 连锁订单汇总
 */
// 导出
export const exportFileApi = params => ajax.post('chainOrder/exportChainOrderRecords', params)

// 查询列表
export const searchChainOrderList = params => ajax.post('chainOrder/queryChainOrderList', params)

// 查询汇总信息
export const queryChainOrderSum = params => ajax.post('chainOrder/queryChainOrderSummary', params)

// 是否显示实付金额
export const showRealAmount = params => ajax.post('handover/getShowRealPayAmount', params)


 // ---------预订单管理接口-----------

 // 预约列表接口
 export const reservationOrderByPage = params => ajax.post('order/reservationOrderByPage', params)

 // 预约状态下拉框接口
 export const reservationOrderStatus = params => ajax.post('order/reservationOrderStatus', params)

 // 预约确认订单接口
 export const reservationOrderConfirm = params => ajax.post('/order/reservationOrderConfirm', params)

// 加油确认接口
export const reservationOrderDeliver = params => ajax.post('/order/reservationOrderDeliver', params)

 // 获取加油枪号接口
 export const gunListByGasId = params => ajax.post('/gasInfo/gunListByGasId', params)

 // 取消订单接口
 export const reservationOrderCancel = params => ajax.post('order/reservationOrderCancel', params)

 // 预约订单详情
 export const reservationOrderDetail = params => ajax.post('order/reservationOrderDetail', params)

 // 添加或更新列表配置
 export const saveColumn = params => ajax.post('columnFieldInfo/addOrUpdate', params)

 // 获取对应的配置
 export const getColumn = params => ajax.post('columnFieldInfo/getByMenuCode', params)

 // 获取默认配置
 export const getDefaultColumn = params => ajax.post('columnFieldInfo/getDefaultByMenuCode', params)

 // 上一笔，下一笔
 export const onOrNextorderid = params => ajax.post('/order/get/quick/operation/orderid', params)

 // 拒绝退款原因下拉框接口
 export const reasonRejectRefundOptions = params => ajax.post('/order/cancel/refund/reason', params)
 
 // 支付方式枚举
 export const payTypeList = params => ajax.post('gasMemberAccount/payEnum', params)

 // 查询订单非油品是否退完
 export const nonOilRefund = params => ajax.post('order/check/nonoil/refund', params)

 // 判断tab栏是否存在
 export const orderPageButtonList = params => ajax.post('order/orderPageButtonList', params)

 // 查询-油枪枚举接口
 export const allGasGunOptioons = params => ajax.post('order/allGasGun', params)

 // 查询是否展示油品实付金额
 export const showRealPayAmount = params => ajax.post('order/isShowOilPayAmount', params)
